import { Component } from 'react';
import Raven from 'raven-js';
import DefaultErrorComponent from './DefaultErrorComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.reportError = this.reportError.bind(this);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    this.reportError(error, errorInfo);
  }
  reportError(error, errorInfo) {
    const {
      boundaryName
    } = this.props;
    Raven.captureException(error, {
      tags: {
        boundaryName,
        newApp: 'true'
      },
      extra: errorInfo
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      renderRhumbErrorMarker,
      fallback
    } = this.props;
    if (hasError) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderRhumbErrorMarker && renderRhumbErrorMarker(), fallback || /*#__PURE__*/_jsx(DefaultErrorComponent, {})]
      });
    }
    return this.props.children;
  }
}